import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cashConverter } from "../../../utils";

function CheckDamView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Name of Dam",
      children: prodd?.damName ?? "N/A",
    },
    
    {
      key: "2",
      label: "Height",
      children: prodd?.damHeight ?? "N/A",
    },
    {
      key: "3",
      label: "Volume",
      children: prodd?.damVolume ?? "N/A",
    },
    {
      key: "4",
      label: "Estimated Beneficiaries",
      children: prodd?.damEstBeneficiaries ?? "N/A",
    },
    {
      key: "6",
      label: "Start Date",
      children: (
        <div>
          {prodd?.damStartDate
            ? moment(prodd?.damStartDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "7",
      label: "End Date",
      children: (
        <div>
          {prodd?.damEndDate
            ? moment(prodd?.damEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "8",
      label: "Time Frame",
      children: prodd?.damTimeFrame ?? "N/A",
    },
    {
      key: "8",
      label: "Acreage Farmed",
      children: prodd?.damAcreageFarmed ?? "N/A",
    },
    {
      key: "10",
      label: "Acreage Protected",
      children: prodd?.damAcreageProtected ?? "N/A",
    },
    {
      key: "9",
      label: "Remarks",
      children: prodd?.damRemarks ?? "N/A",
    },
  ];
  const items2 = [
    {
      key: "5",
      label: "County",
      children: prodd?.countyCode ?? "N/A",
    },
    {
      key: "1",
      label: "SubCounty",
      children: prodd?.subCountyCode ?? "N/A",
    },
    {
      key: "2",
      label: "Location",
      children: prodd?.locLocation ?? "N/A",
    },
    {
      key: "3",
      label: "SubLocation",
      children: prodd?.slocLocation ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constName ?? "N/A",
    },
    {
      key: "4",
      label: "Ward",
      children: prodd?.wdWard ?? "N/A",
    }, 
    {
      key: "2",
      label: "Cost",
      children: <div>{cashConverter(prodd?.damCost)}</div>,
    },
    {
      key: "6",
      label: "Dam Type",
      children: prodd?.dmType ?? "N/A",
    },
    {
      key: "7",
      label: "Method of Abstraction",
      children: prodd?.wamType ?? "N/A",
    },
    {
      key: "8",
      label: "Funding Source",
      children: prodd?.damSourceFunds ?? "N/A",
    },
    {
      key: "8",
      label: "Crops",
      children: prodd?.damCrops ?? "N/A",
    },
    {
      key: "9",
      label: "Pathways",
      children: prodd?.damPathways ?? "N/A",
    },
    {
      key: "12",
      label: "Implementing Agency",
      children: prodd?.damAgency ?? "N/A",
    },
    {
      key: "13",
      label: "Managing Entity",
      children: prodd?.damManagingAgency ?? "N/A",
    },
  ];
 
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Dam Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        
      </div>
    </Drawer>
  );
}

export default CheckDamView;
